import React, { useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';  // If using React Router for navigation

const SessionTimeout = () => {
  const navigate = useNavigate();  // For redirecting to the login page
  const idleTimerRef = useRef(null);

  // Logout function
  const handleLogout = () => {
    // Clear any authentication tokens or user data
    localStorage.clear();  // Example for removing a token
    navigate('/');  // Redirect to login page
  };

  // Handler for idle state
  const onIdle = () => {
    handleLogout();  // Call logout when idle
  };

  // Use the idle timer hook
  useIdleTimer({
    ref: idleTimerRef,
    timeout: 20 * 60 * 1000,  // 20 minutes in milliseconds
    onIdle: onIdle,
    debounce: 500,  // Prevents immediate triggering
  });

 
};

export default SessionTimeout;
